<template>
  <v-slide-y-transition mode="out-in">
    <v-container fluid fill-height>
      <v-layout align-center justify-center>
        <v-flex xs12 xl3 lg3 md5 sm8>
          <v-card class="elevation-12">
            <v-toolbar color="primary">
              <v-toolbar-title class="white--text">Login</v-toolbar-title>
              <v-spacer></v-spacer>
            </v-toolbar>
            <v-card-text>
              <v-form>
                <v-text-field
                  prepend-icon="person"
                  name="username"
                  label="Username"
                  v-model="username"
                  v-validate="'required'"
                  :error-messages="errors.first('username')"
                  type="text"
                ></v-text-field>
                <v-text-field
                  prepend-icon="lock"
                  name="password"
                  label="Password"
                  v-model="password"
                  v-validate="'required|min:8'"
                  :error-messages="errors.first('password')"
                  type="password"
                  v-on:keyup.enter="loginOnClick($event)"
                ></v-text-field>
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn flat color="accent">
                <a href="forget_pw" style="text-decoration:none">Forget Password</a>
              </v-btn>
              <v-btn color="accent" @click="loginOnClick($event)">Login</v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </v-slide-y-transition>
</template>

<script>
import auth from "../functions/auth";
import common from "../functions/general";
// import store2 from 'store2';

export default {
  name: "LoginPage", /// try by OWK
  data() {
    return {
      username: "",
      password: ""
    };
  },
  mounted() {
    // store2(false); [note: (OWK) to allow non-registered user access]
  },
  methods: {
    // << old code >>
    // async loginOnClick() {
    //   let self = this;
    //   this.$validator.validateAll().then(async result => {
    //     if (result) {
    //       let login_response = await auth.login({
    //         username: self.username,
    //         password: self.password
    //       });

    //       if (login_response.Status == 1) {
    //         window.location.href = this.$route.query.redirect;
    //         // window.location.href = "/home";
    //         // self.$router.push({ path: "/home" });
    //       } else {
    //         common.wMsgBox.Error(login_response.Description);
    //       }
    //     }
    //   });
    // }
    async loginOnClick(e) {
      let self = this;
      this.$validator.validateAll().then(async result => {
        if (result) {
          let data = {
            "django_login": (e.ctrlKey || e.metaKey) ? 1 : 0,
            "content": {
              username: self.username,
              password: self.password
            }
          };

          let login_response = await auth.login({data});

          if (login_response.Status == 1) {
            window.location.href = this.$route.query.redirect;
            // window.location.href = "/home";
            // self.$router.push({ path: "/home" });
          } else {
            common.wMsgBox.Error(login_response.Description);
          }
        }
      });
    }
  },
  // created (){
  //   auth.hideFooter(true);
  // },
};
</script>

<style>
</style>
